import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@backbase/shared/feature/config';
import CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})
export class InvestSharedDataService {
    private readonly secretKey: string;
    /**
     * Encrypt the savings account info and store in localstorage
     */
    storeSavingsAccountData(data: any) {
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
        localStorage.setItem('savings_account_info', encryptedData);
    }

    /**
     * Decrypt the savings account info from localstorage using the secret
     */
    getSavingsAccountData() {
        const storedSavingsAccountData = localStorage.getItem('savings_account_info') || null;

        if (storedSavingsAccountData === null) {
            this.router.navigate(['/invest/savings-account/open-account/normal'])
        } else {
            const bytes = CryptoJS.AES.decrypt(storedSavingsAccountData, this.secretKey);
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return decryptedData;
        }
        return null;
    }

    removeSavingsAccountData() {
        localStorage.removeItem('savings_account_info')
    }

    /**
     * Store fund account details
     */
    storeFundOrWithdrawUnitTrustAccountData(data: any) {
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
        localStorage.setItem('ut_account_info', encryptedData);
    }

    getFundOrWithdrawUnitTrustAccountData() {
        const storedFundOrWithdrawUnitTrustAccountData = localStorage.getItem('ut_account_info') || null;

        if (storedFundOrWithdrawUnitTrustAccountData === null) {
            this.router.navigate(['/invest/unit-trust'])
        } else {
            const bytes = CryptoJS.AES.decrypt(storedFundOrWithdrawUnitTrustAccountData, this.secretKey);
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return decryptedData;
        }
        return null;
    }

    removeFundOrWithdrawUnitTrustAccountData() {
        localStorage.removeItem('ut_account_info')
    }

    constructor(
        private router: Router,
        @Inject(ENVIRONMENT_CONFIG) environmentConfig: EnvironmentConfig,
    ) {
        this.secretKey = environmentConfig.localStorageEncryptionKey;
    }
}
